// const addTabs = () => {
//     const tabs = document.querySelectorAll('.tabs');

//     // 페이지 로드 시 첫 번째 탭(Italy)을 기본으로 활성화
//     tabs[0].classList.add('tabs--active');

//     tabs.forEach((tab) => {
//         tab.addEventListener('click', function (e) {
//             e.preventDefault();

//             // 모든 탭에서 active 클래스 제거
//             tabs.forEach((t) => t.classList.remove('tabs--active'));

//             // 클릭된 탭에 active 클래스 추가
//             this.classList.add('tabs--active');
//         });
//     });
// };

const packageSwiper = new Swiper('.lng-package__info', {
    slidesPerView: 1,
    draggable: true,
    autoHeight: true,
    pagination: {
        el: '.lng-package__tab',
        clickable: true,
        bulletClass: 'tabs',
        bulletActiveClass: 'tabs--active',
        renderBullet: function (index, className) {
            const title = this.slides[index].dataset.title;
            return `<button class="${className}">
            ${title}
            ${index === 0 ? `<span class="bullet"></span>` : ''}
            </button>`;
        },
    },
    on: {
        // init: () => {
        //     addTabs();
        // },
        slideChangeTransitionStart: (e) => {
            const index = e.activeIndex;
            const bullet = (document.querySelector('.lng-package__tab .bullet').style.cssText =
                `transform: translateX(${100 * index}%)`);
        },
    },
});